import ProjectManagerAside from "./ProjectManagerAside";
import ProjectManagerDashboard from "./Projectmanager_dashboard";
import "./layouts.css"
function ProjectManagerLayout(){

    return(
        <div className="layout">
            <ProjectManagerAside />
            <ProjectManagerDashboard className="mainBlock"/>
          
        </div>
    )

}
export default ProjectManagerLayout;